
export const AWS_SCM_SHIPMENT_B_Y_BOOKING_CLASS: String = "AWS_SCM_SHIPMENT_B_Y_BOOKING";
export const AWS_SCM_SHIPMENT_DMS_BOOKING_CLASS: String = "AWS_SCM_SHIPMENT_DMS_BOOKING";
export const AWS_SCM_SHIPMENT_ASN_CLASS: String = "AWS_SCM_SHIPMENT_ASN";
export const AWS_SCM_SHIPMENT_STATUS_CLASS: String = "AWS_SCM_SHIPMENT_STATUS";
export const AWS_SCM_SHIPPING_REQUEST_CLASS: String = "AWS_SCM_SHIPPING_REQUEST";
export const AWS_SCM_LOAD_SHIPPING_REQUEST_CLASS: String = "AWS_SCM_LOAD_SHIPPING_REQUEST";
export const AWS_SCM_SHIPMENT_RACK_BOOKING: String = "AWS_SCM_SHIPMENT_RACK_BOOKING";
export const AWS_SCM_WAREHOUSE_BOOKING:String = "AWS_SCM_WAREHOUSE_BOOKING";